import PropTypes from 'prop-types';
import React from 'react';

import useArticle from '../../hooks/use_article';
import useTranslation from '../../hooks/use_translation';
import Trans from '../translation/trans';

const FaqMarker = ({ children, include_markers }) => {
	let empty = true;
	const { items: articles } = useArticle({
		include_markers,
		include_types: ['support'],
		sort: { key: 'article_id', order: 'asc' },
	});
	const { t } = useTranslation('component_faq_marker');

	if (!articles || !articles.length) return;
	const component = (
		<>
			{articles.map((article, index) => {
				if (empty) empty = false;

				return (
					<div className="accordion-item" key={index}>
						<h4
							className="accordion-header"
							id={`marker-group-${article.article_id}`}
						>
							<button
								aria-controls={`marker-group-content-${article.article_id}`}
								aria-expanded="false"
								className="accordion-button d-flex sm bg-gray-100 collapsed"
								data-bs-target={`#marker-group-content-${article.article_id}`}
								data-bs-toggle="collapse"
								type="button"
							>
								{article.article_variant.title}
							</button>
						</h4>
						<div
							aria-labelledby={`marker-group-${article.article_id}`}
							className={`accordion-collapse collapse `}
							id={`marker-group-content-${article.article_id}`}
						>
							<div className="accordion-body bg-gray-100 accordion-body-sm px-0 pt-0">
								<Trans defaults={article.article_variant.content} t={t} />
							</div>
						</div>
					</div>
				);
			})}
		</>
	);

	return children ? <>{children(empty ? null : component)}</> : component;
};

FaqMarker.propTypes = {
	children: PropTypes.any,
	include_markers: PropTypes.array,
};

export default FaqMarker;
